import React, { useCallback, useEffect, useRef, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import TeacherPinDialog from '../components/TeacherPinDialog';
import { clearTeacherSession, readTeacherSession, saveTeacherSession, teacherRequest } from '../teacherModeApi';
import WheelLettersEditor from './WheelLettersEditor';

export default function LearnedLettersDialog({ token, onSaved, onCancel }) {
  const [ready, setReady] = useState(false);
  const [pinOpen, setPinOpen] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const editor = useRef(null);
  const request = useCallback(async (path, options) => {
    const credential = readTeacherSession(token);
    try { return await teacherRequest(token, path, credential, options); }
    catch (err) {
      if (err.status === 401 && readTeacherSession(token) === credential) { clearTeacherSession(token); setPinOpen(true); }
      throw err;
    }
  }, [token]);
  const validate = useCallback(() => request('session').then(() => setReady(true)).catch(err => setError(err.message)), [request]);
  useEffect(() => { validate(); }, [validate]);
  const load = useCallback(() => request('wheel'), [request]);
  const save = useCallback(body => request('wheel', { method: 'PUT', body: JSON.stringify(body) }), [request]);
  const close = () => editor.current ? editor.current.requestClose() : onCancel();
  const login = async event => {
    event.preventDefault(); if (busy || pin.length !== 4) return;
    setBusy(true); setError('');
    try {
      const result = await teacherRequest(token, 'login', null, { method: 'POST', body: JSON.stringify({ pin }) });
      saveTeacherSession(token, result.session_token); setReady(true); setPinOpen(false); setPin('');
    } catch (err) { setError(err.message); setPin(''); }
    finally { setBusy(false); }
  };
  return <>
    <Dialog open onClose={close} maxWidth="md" fullWidth PaperProps={{ 'aria-label': 'Öğrenilen Harfler', sx: { borderRadius: 5, m: 1, width: 'calc(100% - 16px)' } }}>
      <DialogContent sx={{ p: 0 }}>
        {ready ? <WheelLettersEditor ref={editor} shared loadSettings={load} saveSettings={save} onSaved={onSaved} onCancel={onCancel} /> : <>
          {error && !pinOpen && <Alert severity="error" action={<Button onClick={validate}>Tekrar Dene</Button>}>{error}</Alert>}
          <Button onClick={onCancel} sx={{ minHeight: 44 }}>Vazgeç</Button>
        </>}
      </DialogContent>
    </Dialog>
    <TeacherPinDialog open={pinOpen} pin={pin} onPinChange={setPin} onClose={() => { setPinOpen(false); close(); }} onSubmit={login} busy={busy} error={error} />
  </>;
}
